import React from 'react';
import { Provider } from 'react-redux';
import { RelayEnvironmentProvider } from 'react-relay';

import { ICalendar } from './calendar/calendar';
import CalendarWrapper from './calendar/calendarWrapper';
import AccessContainer from './components/AccessContainer';
import GantCalendarLoader from './gant/gantCalendarLoader';
import { store } from './store';

const outCalendar: React.FC<ICalendar> = ({
    paddingBottom,
    environment,
    newTask,
    activePage = 'schedule',
    authorId,
    onFinishLoadData,
    onTasksImport,
}) => {
    const calendarComponent = (
        <AccessContainer accessFor={['schedule-task']} isAlert>
            <GantCalendarLoader onFinishLoadData={onFinishLoadData} authorId={authorId} />
            <CalendarWrapper
                paddingBottom={paddingBottom}
                authorId={authorId}
                activePage={activePage}
                newTask={newTask}
                onTasksImport={onTasksImport}
            />
        </AccessContainer>
    );

    return (
        <Provider store={store}>
            {environment ? (
                <RelayEnvironmentProvider environment={environment}>{calendarComponent}</RelayEnvironmentProvider>
            ) : (
                calendarComponent
            )}
        </Provider>
    );
};

export default outCalendar;
